/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericCounterResponse } from '../../models/generic-counter-response';

export interface GetUnassignedEarlyPickupCasesCount$Params {
}

export function getUnassignedEarlyPickupCasesCount(http: HttpClient, rootUrl: string, params?: GetUnassignedEarlyPickupCasesCount$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericCounterResponse>> {
  const rb = new RequestBuilder(rootUrl, getUnassignedEarlyPickupCasesCount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenericCounterResponse>;
    })
  );
}

getUnassignedEarlyPickupCasesCount.PATH = '/api/v1/statistics-dashboard/unassigned_cases_early_pickup';
